import React from 'react';
import { useProfile } from '@bitbot/model';
import Image from 'next/image';
import clsx from 'clsx';

//当前登录用户的头像，没有像使用name
export default function SelfAvatar({ className }: { className?: string }) {
  const { userInfo } = useProfile();

  return (
    <div
      className={clsx(
        className,
        'rounded-full overflow-hidden w-full h-full',
      )}
    >
      {userInfo?.avatar ? (
        <Image
          src={userInfo?.avatar}
          width={48}
          height={48}
          alt=""
          className="w-full h-full"
        />
      ) : userInfo?.nickname ? (
        <div className="w-full h-full uppercase flex justify-center items-center rounded-full bg-secondary text-primary">
          {userInfo?.nickname.substring(0, 2)}
        </div>
      ) : (
        <div className="w-full h-full uppercase flex justify-center items-center rounded-full bg-secondary"></div>
      )}
    </div>
  );
}
